function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { worldViewerWindow } from './const';
import { debugLog } from './debugLog';
import { getMainCanvasDOMElement } from './logics/domOps';
/**
 * @remarks
 * C++, heliodor.jsから呼出があるためglobal関数
 *
 * @param visible
 */ worldViewerWindow.hel_video_set_movieviewer_ui = (visible)=>{
    // ※スライダーの表示・非表示ははCPPで制御してます。
    // ※スライダーも同時に表示制御したい場合は、 heliodor_front.js の
    // hel_video_set_movieviewer_ui_all() を使う事。
    // console.log("*** hel_video_set_movieviewer_ui(" + visible + ")");
    // 停止中？
    const paused = worldViewerWindow.hel_video_is_paused();
    // --------------------------------------------
    // movieviewer/_po.json の Toggle を設定する。
    // (1)一旦デフォルト値にする（＝movieviewer/_po.jsonのToggle値にする）
    worldViewerWindow.hel_canvas_ResetToggleDefault('IsVisible_VideoPlayerCurrentTime'); // true
    worldViewerWindow.hel_canvas_ResetToggleDefault('IsVisible_VideoPlayerTotalTime'); // true
    worldViewerWindow.hel_canvas_ResetToggleDefault('IsVisible_hud_movie_play'); // false
    worldViewerWindow.hel_canvas_ResetToggleDefault('IsVisible_hud_movie_pause'); // true
    worldViewerWindow.hel_canvas_ResetToggleDefault('IsVisible_hud_movie_forward'); // true
    worldViewerWindow.hel_canvas_ResetToggleDefault('IsVisible_hud_movie_rewind'); // true
    // (2)再設定
    if (visible) {
        // 表示させる
        if (paused) {
            // ポーズ中ならデフォルト値を反転
            worldViewerWindow.hel_canvas_ToggleChange('IsVisible_hud_movie_play'); // false => true
            worldViewerWindow.hel_canvas_ToggleChange('IsVisible_hud_movie_pause'); // true => false
        }
    } else {
        // 表示させない
        worldViewerWindow.hel_canvas_ToggleChange('IsVisible_VideoPlayerCurrentTime'); // true => false
        worldViewerWindow.hel_canvas_ToggleChange('IsVisible_VideoPlayerTotalTime'); // true => false
        worldViewerWindow.hel_canvas_ToggleChange('IsVisible_hud_movie_pause'); // true => false
        worldViewerWindow.hel_canvas_ToggleChange('IsVisible_hud_movie_forward'); // true => false
        worldViewerWindow.hel_canvas_ToggleChange('IsVisible_hud_movie_rewind'); // true => false
    }
    // -----------------------------------------
    // 横画面
    let layout_name = 'movieviewer';
    worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'VideoPlayerCurrentTime', visible);
    worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'VideoPlayerTotalTime', visible);
    if (paused) {
        worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'hud_movie_play', visible);
        worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'hud_movie_pause', false);
    } else {
        worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'hud_movie_play', false);
        worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'hud_movie_pause', visible);
    }
    worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'hud_movie_forward', visible);
    worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'hud_movie_rewind', visible);
    // 縦画面
    layout_name = 'movieviewer_po';
    worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'VideoPlayerCurrentTime', visible);
    worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'VideoPlayerTotalTime', visible);
    if (paused) {
        worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'hud_movie_play', visible);
        worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'hud_movie_pause', false);
    } else {
        worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'hud_movie_play', false);
        worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'hud_movie_pause', visible);
    }
    worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'hud_movie_forward', visible);
    worldViewerWindow.hel_canvas_SetGUIShow(layout_name, 'hud_movie_rewind', visible);
};
/**
 * @remarks
 * C++から呼び出される
 * スクリーンショット
 */ worldViewerWindow.hel_screenshot = ()=>{
    const mainCanvas = getMainCanvasDOMElement();
    if (mainCanvas === undefined) {
        debugLog('[ hel_screenshot ] mainCanvas is not assigned. noop');
        return;
    }
    // dataURLを保存と共有用にローカルストレージに保持しておく
    window.localStorage['ssBase64'] = mainCanvas.toDataURL('image/jpeg');
    // iPhoneでのスクショ
    // 通常の方法でスクショを撮影するとSkywayが切断されてしまうため、このようにしている
    // modalSSを開いたら後の処理はスキップする
    if (worldViewerWindow.hel_isiPhone() && mainCanvas !== undefined) {
        modalSS.show();
        return;
    }
    // その他のデバイスでのスクショ
    mainCanvas.toBlob((blob)=>{
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        const today = new Date();
        a.download = '' + today.getFullYear() + ('00' + (today.getMonth() + 1)).slice(-2) + ('00' + today.getDate()).slice(-2) + '_' + ('00' + today.getHours()).slice(-2) + ('00' + today.getMinutes()).slice(-2) + ('00' + today.getSeconds()).slice(-2) + '.png';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    });
};
/**
 * HSから参照
 */ worldViewerWindow.hel_share_screenshot = async (sharetitle, sharetext)=>{
    const ssDataURL = window.localStorage["ssBase64"];
    // blobに変換
    const blob = await (await fetch(ssDataURL)).blob();
    if (blob === undefined || blob === null) return false;
    // ファイル名を決定
    const paramList = blob.type.split("/");
    var extention = "png";
    if (paramList.length == 2) extention = paramList[1];
    const today = new Date();
    const fileName = today.getFullYear() + ('00' + (today.getMonth() + 1)).slice(-2) + ('00' + today.getDate()).slice(-2) + '_' + ('00' + today.getHours()).slice(-2) + ('00' + today.getMinutes()).slice(-2) + ('00' + today.getSeconds()).slice(-2) + "." + extention;
    // Fileオブジェクトに変換
    const file = new File([
        blob
    ], fileName, {
        type: blob.type
    });
    // Web Share APIを実行
    return await worldViewerWindow.hel_share_file(sharetitle, sharetext, file);
};
worldViewerWindow.hel_share_file = async (sharetitle, sharetext, sharefile)=>{
    if (navigator.share === undefined) {
        // navigator.shareはセキュリティ対策でhttps環境でしか使用できない
        console.error("[Error] navigator.share is undefined. It is available when using HTTPS.");
        return false;
    }
    const result = await navigator.share({
        title: sharetitle,
        text: sharetext,
        files: [
            sharefile
        ]
    }).then(()=>{
        return true;
    }).catch((error)=>{
        console.error(error);
        return false;
    });
    return result;
};
/**
 * HSから参照
 */ worldViewerWindow.hel_copy_screenshot_to_clipboard = async ()=>{
    const ssDataURL = window.localStorage["ssBase64"];
    // jpegのスクリーンショットをpngに変換した上でクリップボードにコピーする
    // localstorageにjpegを保存しているのはpngだとシーンによっては最大容量の5MBを超えてQuotaExceededErrorが出てしまうため
    // しかしclipboard.writeはpngしか対応していないため変換する必要がある
    // また、clipboard.writeよりも前に非同期処理があるとMac + SafariでNotAllowedErrorが出てしまうことにも注意
    const result = await navigator.clipboard.write([
        new ClipboardItem({
            'image/png': convert_jpeg_to_png(ssDataURL)
        })
    ]).then(()=>{
        return true;
    }).catch((error)=>{
        console.error(error);
        return false;
    });
    return result;
};
const convert_jpeg_to_png = async (jpegDataURL)=>{
    return new Promise((resolve, reject)=>{
        //
        var img = new Image();
        img.src = jpegDataURL;
        //
        img.onload = ()=>{
            // jpeg画像をCanvasに描画する
            var tmpCanvas = document.createElement('canvas');
            tmpCanvas.width = img.width;
            tmpCanvas.height = img.height;
            var ctx = tmpCanvas.getContext('2d');
            ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(img, 0, 0);
            // 描画に使ったCanvasをpng形式のblobに変換する
            tmpCanvas.toBlob((blob)=>{
                tmpCanvas.remove();
                if (blob) {
                    resolve(blob);
                } else {
                    reject(new Error("[Error] Failed to convert jpeg to png."));
                }
            }, 'image/png');
        };
    });
};
// URL
/**
 * C++から参照
 * @param url
 */ // eslint-disable-next-line @typescript-eslint/no-shadow
worldViewerWindow.hel_openPage = (url)=>{
    if (EnabledExternalCheck() && IsWorldLink(url)) {
        // 遷移先でも外部リンクチェックをしたいのでifexternalフラグを引き継ぐ
        url = worldViewerWindow.hel_set_QueryParam('ifexternal', '1', url);
    }
    // iOSでは非同期処理中にopenが使用できないのでその時はページ遷移を行う
    if (!worldViewerWindow.open(url, '_blank')) {
        worldViewerWindow.location.href = url;
    }
};
/**
 * C++とCanvasHSから参照
 * @param url
 */ // eslint-disable-next-line @typescript-eslint/no-shadow
worldViewerWindow.hel_transitionToPage = (url)=>{
    if (EnabledExternalCheck()) {
        // 外部リンクチェックが有効で遷移先がワールド以外の外部リンクなら強制的に別タブ遷移する
        // iframeで外部リンクを同タブで開こうとすると失敗するのでその対策
        if (!IsWorldLink(url)) {
            worldViewerWindow.hel_openPage(url);
            return;
        }
        // 遷移先でも外部リンクチェックをしたいのでifexternalフラグを引き継ぐ
        url = worldViewerWindow.hel_set_QueryParam('ifexternal', '1', url);
    }
    // ページ遷移
    worldViewerWindow.location.href = url;
};
const EnabledExternalCheck = ()=>{
    // 外部リンクチェックを行うかどうか
    const ifexternal = worldViewerWindow.hel_get_QueryParam('ifexternal'); // 現在のインゲームURLからフラグ取得
    return ifexternal == '1';
};
const IsWorldLink = (url)=>{
    // 遷移先がワールドかどうか
    const worldid = worldViewerWindow.hel_get_QueryParam('worldid', url); // 遷移先URLからフラグ取得
    return worldid != '';
};
/**
 * Cppから参照
 */ worldViewerWindow.hel_get_QueryParam = (queryName, srcURL)=>{
    if (srcURL === undefined || srcURL === null || srcURL == "") {
        srcURL = document.location.href;
    }
    // @ts-ignore
    const params = new URL(srcURL).searchParams;
    const QueryParam = params.get(queryName);
    if (QueryParam === undefined || QueryParam === null) {
        return '';
    }
    return QueryParam;
};
/**
 * HS, TSから参照
 */ worldViewerWindow.hel_set_QueryParam = (queryName, queryValue, srcURL)=>{
    // @ts-ignore
    var urlObj = new URL(srcURL);
    urlObj.searchParams.set(queryName, queryValue);
    return urlObj.href;
};
/**
 * HeliScriptから参照
 */ worldViewerWindow.hel_set_HTMLElement_value = (elementName, value)=>{
    const element = document.getElementById(elementName);
    if (element !== undefined && element != null) {
        element.value = value;
    }
};
/**
 * HeliScriptから参照
 */ worldViewerWindow.hel_get_HTMLElement_value = (elementName)=>{
    const element = document.getElementById(elementName);
    if (element !== undefined && element != null) {
        const value = element.value;
        return value !== undefined && value !== null ? value : '';
    }
    return '';
};
/**
 * UUID
 * HeliScriptから参照
 */ worldViewerWindow.hel_get_randomUUID = ()=>{
    return self.crypto.randomUUID();
};
// ScreenShot Class
class ModalSS {
    show() {
        if (this.container !== null) this.container.style.visibility = 'visible';
    }
    hide() {
        if (this.container !== null) this.container.style.visibility = 'hidden';
    }
    constructor(){
        _defineProperty(this, "container", void 0);
        _defineProperty(this, "btnOpenSS", void 0);
        _defineProperty(this, "btnClose", void 0);
        //
        this.container = document.querySelector('#__ss_modal');
        //
        this.btnOpenSS = document.querySelector('#__ss_modal-dialog-btn_open_ss');
        if (this.btnOpenSS !== null) {
            this.btnOpenSS.addEventListener('click', ()=>{
                this.hide();
            });
        }
        //
        this.btnClose = document.querySelector('#__ss_modal-dialog-btn_close');
        if (this.btnClose !== null) {
            this.btnClose.addEventListener('click', ()=>{
                this.hide();
            });
        }
    }
}
const modalSS = new ModalSS();
